export default "__VITE_ASSET__cQJJyYm0__"